

<script>
    import { onMount } from 'svelte';
    import { gsap } from 'gsap';
    
    // Component props
    export let content = {};
    export let currentLang = 'hu';
    export let onSelectService; // Function to call when a service is selected
    
    // Define service data with images and colors matching home page
    const services = [
      {
        id: 'airportParking',
        color: '#2b0f4d',
        hoverColor: '#1f0839',
        image: 'images/parking-lot.webp',
        svgIcon: `<svg fill="#ffffff" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M12,6H9A1,1,0,0,0,8,7V17a1,1,0,0,0,2,0V14h2a4,4,0,0,0,0-8ZM12,12H10V8h2a2,2,0,0,1,0,4ZM19,2H5A3,3,0,0,0,2,5V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"></path></g></svg>`
      },
      {
        id: 'carWash',
        color: '#003a70',
        hoverColor: '#002851',
        image: 'images/car-wash.webp',
        svgIcon: `<svg fill="#ffffff" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M142.25,206.819c-11.982,0.247-23.234-6.299-28.755-17.521l-2.751-5.591H62.71l1.296-5.894 c-5.764-0.319-11.242-2.802-15.533-7.128c-4.972-5.008-8.189-12.11-9.732-21.491l-14.374,65.334l0.249,60.473 C10.504,278.339,0,291.007,0,306.138c0,17.674,14.326,32,32,32h22.252c0-39.307,31.979-71.286,71.286-71.286 c12.595,0,24.428,3.297,34.707,9.052v-69.417L142.25,206.819z"></path> </g> </g> <g> <g> <path d="M301.995,74.561c-4.888-8.729-14.137-14.15-24.14-14.15H136.613c5.117,8.867,4.418,20.507,2.632,30.824h39.416 c8.615-10.736,21.831-17.628,36.636-17.628c14.804,0,28.021,6.892,36.636,17.628h24.074l50.407,90.015 c-0.493-4.596,0.054-9.945,2.447-16.113c2.611-6.727,8.117-12.181,14.736-16.29L301.995,74.561z"></path> </g> </g> <g> <g> <path d="M352.07,260.154c-3.421-4.743-6.068-9.242-8.122-13.501l-40.47,13.681c-11.896,4.025-24.553,0.473-32.751-8.072 c0,67.969,0.052,26.197,0.052,85.876h55.885c0-27.503,15.665-51.4,38.532-63.283C360.825,271.131,356.463,266.245,352.07,260.154z "></path> </g> </g> <g> <g> <path d="M490.667,275.966c0-4.949,0-10.028,0-15.137h-23.202c-11.436,0-20.706-9.27-20.706-20.706 c0-11.436,9.27-20.706,20.706-20.706h20.006c-7.529-20.927-27.547-35.896-51.066-35.896h-20.637 c3.383,11.767,5.348,26.998-1.26,39.26c-5.568,10.331-4.45,31.472-4.45,36.857c0,2.834-0.471,5.526-1.302,8.034 c34.198,5.222,60.48,34.833,60.48,70.468c3.943,0,6.995,0,10.765,0c17.672,0,32-14.328,32-32 C512,292.206,503.094,280.36,490.667,275.966z"></path> </g> </g> <g> <g> <path d="M125.539,289.327c-26.957,0.001-48.81,21.854-48.81,48.811s21.853,48.81,48.81,48.81c13.359,0,25.459-5.371,34.272-14.066 v-69.488C150.997,294.698,138.897,289.327,125.539,289.327z M125.539,357.908c-10.919,0-19.77-8.851-19.77-19.77 s8.851-19.77,19.77-19.77c10.919,0,19.77,8.851,19.77,19.77S136.458,357.908,125.539,357.908z"></path> </g> </g> <g> <g> <path d="M397.949,289.328c-26.957,0-48.81,21.853-48.81,48.81c0,26.957,21.852,48.81,48.81,48.81 c26.957,0,48.81-21.853,48.81-48.81C446.758,311.181,424.906,289.328,397.949,289.328z M397.949,357.908 c-10.919,0-19.77-8.851-19.77-19.77s8.851-19.77,19.77-19.77s19.77,8.851,19.77,19.77S408.868,357.908,397.949,357.908z"></path> </g> </g> <g> <g> <path d="M384.574,159.738c-2.448-2.26-6.1-3.212-10.227-3.212c-11.621,0-26.995,7.553-29.773,14.712 c-1.873,4.827-1.758,8.322-0.671,11.21c13.144,0.327,24.716,8.792,28.945,21.305c4.753,14.058-1.07,29.178-13.161,36.697 c1.569,3.091,3.544,6.362,6.055,9.844c8.994,12.472,16.122,16.696,20.858,16.696c4.271,0,6.597-3.434,6.597-7.353 c0-6.78-1.437-30.186,6.469-44.854C407.572,200.115,393.916,168.361,384.574,159.738z"></path> </g> </g> <g> <g> <path d="M123.24,72.004C120.8,59.525,92.948,52.038,84.177,57.639c-13.97,8.921-3.438,18.865-9.36,29.381 c-5.923,10.516-20.068,17.661-20.289,46.903c-0.154,20.329,5.579,27.099,10.73,27.099c2.259,0,4.406-1.303,5.895-3.335 c2.548-3.478,8.601-12.716,16.538-20.826l-1.148-2.332c-7.641-15.526-1.226-34.374,14.301-42.016 c6.617-3.257,14.104-4.104,21.46-2.291C123.718,82.948,124.069,76.249,123.24,72.004z"></path> </g> </g> <g> <g> <path d="M356.879,209.151c-0.001-0.003-0.002-0.007-0.003-0.01c-2.563-7.571-10.85-11.669-18.409-9.099 c-14.502,4.902-23.759,8.033-38.712,13.087c-4.507-7.356-15.44-25.202-20.63-33.671c-7.251-11.835-20.379-19.185-34.258-19.185 c-83.287,0-60.216-0.155-94.254,0.474c-4.401-8.943-18.447-37.486-22.879-46.493c-3.565-7.248-12.34-10.118-19.448-6.62 c-7.199,3.543-10.163,12.249-6.621,19.447c16.505,33.54,11.631,23.638,26.954,54.773c2.49,5.06,7.758,8.245,13.302,8.11 c37.258-0.689,34.271-0.64,35.182-0.64c0,0.256-0.435,84.692-0.435,249.492c0,9.627,7.805,17.431,17.431,17.431 c9.625,0,17.431-7.804,17.431-17.431c0-14.798,0-110.297,0-125.829h7.526c0,15.538,0,110.994,0,125.829 c0,9.627,7.805,17.431,17.431,17.431c9.627,0,17.431-7.804,17.431-17.431c0-54.87-0.049-180.103-0.051-239.359 c0-0.709,0.471-1.331,1.153-1.524c0.682-0.193,1.41,0.09,1.781,0.694c3.083,5.025,9.717,15.869,24.234,39.564 c3.537,5.771,10.603,8.352,17.041,6.174c31.192-10.545,16.238-5.49,49.694-16.801 C355.383,224.992,359.442,216.736,356.879,209.151z"></path> </g> </g> <g> <g> <circle cx="215.299" cy="120.568" r="30.709"></circle> </g> </g> </g></svg>`
      }
    ];
    
    // Track hover state for each card
    let hoveredCard = null;
    
    function setHovered(index) {
      hoveredCard = index;
    }
    
    function clearHovered() {
      hoveredCard = null;
    }
    
    // Animation state
    let servicesLoaded = false;
    
    // Function to select a service
    function selectService(serviceId) {
      // Call the parent component's function with the selected service ID
      onSelectService(serviceId);
    }
    

  </script>
  
  <section class="service-selection-section">
    <div class="container">
      <h2 class="section-title">{content[currentLang].serviceSelection.title}</h2>
      <p class="section-subtitle">{content[currentLang].serviceSelection.description}</p>
  
      <div class="services-grid" class:visible={servicesLoaded}>
        {#each services as service, i}
          <button 
            class="service-card {hoveredCard === i ? 'hovered' : ''}" 
            style={`--card-color: ${service.color}; --card-hover: ${service.hoverColor}`}
            on:click={() => selectService(service.id)} 
            on:keydown={(e) => e.key === 'Enter' && selectService(service.id)} 
            on:mouseenter={() => setHovered(i)}
            on:mouseleave={clearHovered}
            tabindex="0" 
            role="button"
          >
            <div class="bg-image" style={`background-image: url('${service.image}')`}></div>
            <div class="color-overlay"></div>
            
            <div class="service-icon">
              {@html service.svgIcon}
            </div>
            <h3>{content[currentLang].services[service.id].title}</h3>
            <p>{content[currentLang].services[service.id].description}</p>
            <div class="service-action">
              <span>{currentLang === 'hu' ? 'Foglalás' : 'Book Now'}</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </button>
        {/each}
      </div>
    </div>
  </section>
  
  <style>
    /* Service Selection Section */
    .service-selection-section {
      padding: 5rem 2rem;
      background-color: var(--light);
    }
  
    .section-title {
      text-align: center;
      margin-bottom: 1rem;
      font-size: 2.2rem;
      position: relative;
    }
  
    .section-title::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background-color: rgba(27, 42, 75, 0.7);
    }
  
    .section-subtitle {
      text-align: center;
      max-width: 700px;
      margin: 0 auto 3rem;
      color: var(--text-light);
      font-size: 1.1rem;
    }
  
    .services-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
      margin-top: 3rem;
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
    }
    
    .services-grid.visible {
      opacity: 1;
    }
  
    .service-card {
      position: relative;
      border-radius: 10px;
      overflow: hidden;
      padding: 30px 25px;
      height: 100%;
      min-height: 300px;
      display: flex;
      flex-direction: column;
      transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
      z-index: 1;
      border: none;
      width: 100%;
      text-align: left;
      cursor: pointer;
      background: transparent;
    }
  
    .service-card:hover,
    .service-card.hovered {
      transform: translateY(-10px) scale(1.03);
      box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25);
      outline: none;
    }
  
    .service-card:focus {
      outline: 2px solid rgba(255, 255, 255, 0.5);
      outline-offset: 2px;
    }

    .bg-image {
      position: absolute;
      inset: 0;
      background-size: cover;
      background-position: center;
      z-index: 0;
      transform: scale(1.02);
    }

    .color-overlay {
      position: absolute;
      inset: 0;
      background-color: var(--card-color);
      opacity: 0.75;
      z-index: 1;
      transition: opacity 0.3s ease, background-color 0.3s ease;
    }

    .service-card.hovered .color-overlay {
      background-color: var(--card-hover);
      opacity: 0.9;
    }
  
    .service-icon {
      width: 70px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.16);
      border-radius: 16px;
      margin-bottom: 20px;
      position: relative;
      z-index: 2;
      transition: all 0.3s ease;
    }
  
    .service-card.hovered .service-icon {
      transform: scale(1.05);
    }
  
    .service-icon :global(svg) {
      width: 35px;
      height: 35px;
      color: white;
    }
  
    .service-card h3 {
      font-size: 1.4rem;
      margin-bottom: 15px;
      color: #fff;
      font-weight: 600;
      position: relative;
      z-index: 2;
    }

    .service-card p {
      font-size: 0.9rem;
      line-height: 1.6;
      color: rgba(255, 255, 255, 0.9);
      margin-bottom: 20px;
      flex-grow: 1;
      position: relative;
      z-index: 2;
    }
  
    .service-action {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-weight: 600;
      font-size: 0.9rem;
      color: #f4f7ff;
      position: relative;
      z-index: 2;
      transition: all 0.3s ease;
      cursor: pointer;
      padding: 10px 14px;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.14);
      border: 1px solid rgba(255, 255, 255, 0.22);
      margin-top: auto;
      align-self: center;
    }

    .service-action:focus {
      outline: 2px solid #f4f7ff;
      outline-offset: 2px;
      border-radius: 4px;
    }

    .service-card.hovered .service-action {
      color: #ffffff;
      background: rgba(255, 255, 255, 0.2);
    }
  
    /* Responsive Styles */
    @media screen and (max-width: 1200px) {
      .services-grid {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  
        @media screen and (max-width: 768px) {
      .section-title {
        font-size: 1.8rem;
      }

      .section-subtitle {
        font-size: 1rem;
      }

      .services-grid {
        grid-template-columns: 1fr;
        gap: 1.5rem;
      }
      
      .service-card {
        min-height: 250px;
        padding: 25px 20px;
        text-align: center;
      }

      .service-icon {
        margin: 0 auto 1.2rem;
      }
      
      .service-card h3 {
        font-size: 1.3rem;
      }
      
      .service-card p {
        font-size: 0.9rem;
      }

      .service-action {
        font-size: 1.1rem;
        padding: 1rem 2.5rem;
        min-height: 52px;
        width: 100%;
        max-width: 220px;
        margin: 1rem auto 0;
      }
    }
  
    @media screen and (max-width: 480px) {
      .section-title {
        font-size: 1.5rem;
      }
      
      .section-subtitle {
        font-size: 0.9rem;
      }

      .service-card {
        min-height: 260px;
        padding: 1.2rem;
      }

      .service-action {
        font-size: 1rem;
        padding: 0.9rem 2rem;
        min-height: 48px;
        max-width: 200px;
      }
    }
    </style>